// Ð Ð°Ð·Ð±Ð¾Ñ Ð¾ÑÐ²ÐµÑÐ° Ð±ÑÐºÐµÐ½Ð´Ð° Ð½Ð° Â«ÑÑÐ¾ Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑÂ».
//
// ÐÑÐºÐµÐ½Ð´ Ð·Ð°Ð²Ð¾ÑÐ°ÑÐ¸Ð²Ð°ÐµÑ Ð½Ð°ÑÐ¸ Ð¶Ðµ ArgumentException Ð² Ð¾Ð±ÑÐ¸Ð¹ ÐºÐ¾Ð½Ð²ÐµÑÑ Ð¸ Ð¿ÑÐ¸ÐºÐ»ÐµÐ¸Ð²Ð°ÐµÑ
// Ðº ÑÐµÐºÑÑÑ ÑÑÐµÐº:
//
//   { "message": "ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ°",
//     "error": "ÐÐ±ÑÐ°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°: ÐÐ»Ð¸ÐµÐ½Ñ ÑÐµÐ¹ÑÐ°Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ²Ð°ÐµÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ. ÐÐ¾Ð¶Ð´Ð¸ÑÐµÑÑâ¦
//               \nStack:   at doscar.Data.Shop.Mocks.MockCreditPlatformâ¦" }
//
// ÐÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð½ÑÐ¶Ð½Ð° ÑÐ¾Ð»ÑÐºÐ¾ Ð¿ÐµÑÐ²Ð°Ñ ÑÑÐ°Ð·Ð°. Ð¡ÑÐµÐº, Ð½Ð¾Ð¼ÐµÑÐ° ÑÑÑÐ¾Ðº Ð¸ Ð¸Ð¼ÐµÐ½Ð° ÐºÐ»Ð°ÑÑÐ¾Ð² Ð¾Ð½
// Ð¿ÑÐ¾ÑÐ¸ÑÐ°ÑÑ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð¸ Ð²ÑÑ ÑÐ°Ð²Ð½Ð¾ Ð¿ÑÐ¸Ð´ÑÑ Ñ Ð²Ð¾Ð¿ÑÐ¾ÑÐ¾Ð¼ â Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð²ÑÑÐ°ÑÐºÐ¸Ð²Ð°ÐµÐ¼
// ÑÐµÐ»Ð¾Ð²ÐµÑÐµÑÐºÑÑ ÑÐ°ÑÑÑ, Ð° ÑÐµÑÐ½Ð¸ÑÐµÑÐºÑÑ Ð¾ÑÑÐ°Ð²Ð»ÑÐµÐ¼ ÑÐ°Ð·ÑÐ°Ð±Ð¾ÑÑÐ¸ÐºÑ Ð² Ð¼Ð¾Ð´Ð°Ð»ÐºÐµ.

// ÐÑÑÐ¾Ñ, Ð¿Ð¾ÑÐ»Ðµ ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð½Ð°ÑÐ¸Ð½Ð°ÐµÑÑÑ ÑÑÐµÐº Ð¸Ð»Ð¸ ÑÐ»ÑÐ¶ÐµÐ±Ð½Ð°Ñ ÑÐ°ÑÑÑ Ð¾ÑÐ²ÐµÑÐ°.
const TECHNICAL_MARKERS = [
  '\nStack',
  'Stack:',
  '\n   at ',
  ' at doscar.',
  ' at Microsoft.',
  ' at System.',
  'System.ArgumentException',
  'System.Exception',
];

const PREFIXES = ['ÐÐ±ÑÐ°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°:', 'ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ°:', 'ÐÑÐ¸Ð±ÐºÐ°:'];

const cut = (text) => {
  let result = text;
  TECHNICAL_MARKERS.forEach((marker) => {
    const index = result.indexOf(marker);
    if (index > 0) result = result.slice(0, index);
  });
  return result;
};

const stripPrefix = (text) => {
  let result = text.trim();
  PREFIXES.forEach((prefix) => {
    if (result.startsWith(prefix)) result = result.slice(prefix.length).trim();
  });
  return result;
};

// Ð¢ÐµÐºÑÑ Ð±ÐµÐ· ÐµÐ´Ð¸Ð½Ð¾Ð¹ ÐºÐ¸ÑÐ¸Ð»Ð»Ð¸ÑÐµÑÐºÐ¾Ð¹ Ð±ÑÐºÐ²Ñ â ÑÑÐ¾ Ð¿Ð¾ÑÑÐ¸ Ð½Ð°Ð²ÐµÑÐ½ÑÐºÐ° ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¾Ñ
// ÑÑÐ¾ÑÐ¾Ð½Ð½ÐµÐ³Ð¾ ÑÐµÑÐ²Ð¸ÑÐ° Ð¸Ð»Ð¸ Ð¾Ð±ÑÑÐ²Ð¾Ðº ÑÑÐµÐºÐ°: Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ ÐµÐ³Ð¾ Ð² ÑÐ¾ÑÑÐµ Ð±ÐµÑÑÐ¼ÑÑÐ»ÐµÐ½Ð½Ð¾.
const looksHuman = (text) =>
  text.length >= 10 && text.length <= 400 && /[Ð°-ÑÑ]/i.test(text) && !text.startsWith('{');

/**
 * ÐÐ¾Ð½ÑÑÐ½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ ÑÐµÐºÑÑ Ð¾ÑÐ¸Ð±ÐºÐ¸ Ð¸Ð»Ð¸ null, ÐµÑÐ»Ð¸ ÑÐ°ÐºÐ¾Ð³Ð¾ ÑÐµÐºÑÑÐ° Ð½ÐµÑ
 * (ÑÐ¾Ð³Ð´Ð° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð¼Ð¾Ð´Ð°Ð»ÐºÑ Ñ ÑÐµÑÐ½Ð¸ÑÐµÑÐºÐ¸Ð¼Ð¸ Ð¿Ð¾Ð´ÑÐ¾Ð±Ð½Ð¾ÑÑÑÐ¼Ð¸).
 */
export const humanErrorText = (payload) => {
  if (!payload) return null;

  const raw =
    typeof payload === 'string'
      ? payload
      : payload.errorMessage || payload.error || payload.message;

  if (typeof raw !== 'string') return null;

  const text = stripPrefix(cut(raw)).replace(/\s+/g, ' ').trim();

  // Â«ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ°Â» â ÑÑÐ¾ Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²Ð¾Ðº ÐºÐ¾Ð½Ð²ÐµÑÑÐ°, Ð° Ð½Ðµ Ð¾Ð±ÑÑÑÐ½ÐµÐ½Ð¸Ðµ.
  if (!looksHuman(text) || text === 'ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ°') return null;

  return text;
};
